import styled from 'styled-components';
export const Cstable = styled.div`
  display: table;
  border-collapse: collapse;
  width: 100%;
  .cscell {
    display: table-cell;
    padding: 5px;
    border: 1px solid #d8d8d8;
    color: #333;
  }
  &.tableFare .cscell:nth-child(1),
  &.tableBrkUP .cscell:nth-child(1),
  &.fareRulesTable .cscell:nth-child(1) {
    width: 50%;
  }
  &.tableFare .cscell:nth-child(2) {
    text-align: right;
  }
  &.tableFare .cscell {
    padding: 10px;
  }
  &.baggage .cscell {
    padding: 10px;
  }
`;
export const Csrow = styled.div`
  display: table-row;
  .width30 {
    width: 30%;
  }
  .width35 {
    width: 35%;
  }
`;
export const Cscell = styled.div`
  display: table-cell;
  padding: 5px;
  border: 1px solid #d8d8d8;
`;
export const FareRulesTable = styled.div`
  .frtable {
    width: 47%;
    float: left;
    margin-bottom: 20px;
  }
  .frtable:nth-child(even) {
    float: right;
  }
  .frcell {
    padding: 10px;
    width: 50%;
  }
`;

export const TableFare = styled.div`
  .cscell:nth-child(1),
  .tableBrkUP .cscell:nth-child(1),
  .fareRulesTable .cscell:nth-child(1) {
    width: 50%;
  }
  .cscell {
    padding: 10px;
  }
`;

export const CancellationRules = styled.div`
  .tableFare {
    width: 47%;
    float: left;
    margin-bottom: 20px;
  }
  .tableFare:nth-child(even) {
    float: right;
  }
  .cscell:nth-child(even) {
    background-color: #fafafa;
  }
`;

export const Refundability = styled.div(
  props => `
    ${
      props.isRefundable
        ? `background-image: linear-gradient(
      76deg
      , #00c57e, #18a160);`
        : `background: #f00;`
    }
    border-radius: 2px;
    text-transform: uppercase;
    font-size: 1.1rem;
    padding: 0.5rem;
  `
);
